var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-radios-wrap"},[_c('QuestionBtn',{attrs:{"id":_vm.questionId,"text":"yes","isActive":_vm.isChecked,"onclick":_vm.handleChange}}),_c('QuestionBtn',{attrs:{"id":_vm.questionId,"text":"no","isActive":!_vm.isChecked,"onclick":_vm.handleChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }